import { useIsAuthenticated } from './firebaseMsalCompat';

/**
 * Where "home" is for the current visitor: signed-in users live in their
 * workspace, guests and signed-out visitors on the landing page. Mirrors the
 * redirect in `pages/Home.tsx`, so links can go straight there instead of
 * bouncing through `/`.
 */
export function useHomePath(): '/workspace' | '/' {
  return useIsAuthenticated() ? '/workspace' : '/';
}
